import axios from "axios";
import {
  USER_PROJECT_LIST_FAIL,
  USER_PROJECT_LIST_REQUEST,
  USER_PROJECT_LIST_SUCCESS,
  USER_PROJECT_TIME_LIST_FAIL,
  USER_PROJECT_TIME_LIST_REQUEST,
  USER_PROJECT_TIME_LIST_SUCCESS,
  USER_PROJECT_ADD_TIME_IN_LIST_FAIL,
  USER_PROJECT_ADD_TIME_IN_LIST_REQUEST,
  USER_PROJECT_ADD_TIME_IN_LIST_SUCCESS,
  USER_ADD_WEB_PROJECT_LIST_FAIL,
  USER_ADD_WEB_PROJECT_LIST_REQUEST,
  USER_ADD_WEB_PROJECT_LIST_SUCCESS,
  USER_PROJECT_EDIT_TIME_IN_LIST_FAIL,
  USER_PROJECT_EDIT_TIME_IN_LIST_REQUEST,
  USER_PROJECT_EDIT_TIME_IN_LIST_SUCCESS,
  USER_ALL_REPORT_DATA_LIST_FAIL,
  USER_ALL_REPORT_DATA_LIST_REQUEST,
  USER_ALL_REPORT_DATA_LIST_SUCCESS,
  USER_ALL_USER_CHECKIN_LIST_FAIL,
  USER_ALL_USER_CHECKIN_LIST_REQUEST,
  USER_ALL_USER_CHECKIN_LIST_SUCCESS,
  USER_PROJECT_DELETE_IN_LIST_FAIL,
  USER_PROJECT_DELETE_IN_LIST_REQUEST,
  USER_PROJECT_DELETE_IN_LIST_SUCCESS,
  USER_PROJECT_DELETE_TIME_IN_LIST_FAIL,
  USER_PROJECT_DELETE_TIME_IN_LIST_REQUEST,
  USER_PROJECT_DELETE_TIME_IN_LIST_SUCCESS,
} from "../../types/user/projectTypes";
//import moment from "moment";
import dayjs from "dayjs";

export const userProjectAction = (companyId) => async (dispatch, getState) => {
  try {
    dispatch({
      type: USER_PROJECT_LIST_REQUEST,
    });
    const {
      sharedLogin: { sharedUserInfo },
    } = getState();
    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `${sharedUserInfo?.payload?.token}`,
      },
    };
    const { data } = await axios.get(
      `${process.env.REACT_APP_BACKEND_URI}/api/user/projecttime/${companyId}/project`,
      config
    );
    dispatch({
      type: USER_PROJECT_LIST_SUCCESS,
      payload: data?.data,
    });
  } catch (error) {
    let err =
      error.response &&
      (typeof error.response.data === "string"
        ? error.response.data
        : error.response.data.message
        ? error.response.data.message
        : error.response.data.errors
        ? error.response.data.errors[0].msg
        : error.message);
    if (!err) {
      err = "Network Error";
    }
    //  console.log(err);
    dispatch({
      type: USER_PROJECT_LIST_FAIL,
      payload: err,
    });
    throw Error(err);
  }
};

export const userProjectTimeDateAction =
  (companyId, dated) => async (dispatch, getState) => {
    try {
      dispatch({
        type: USER_PROJECT_TIME_LIST_REQUEST,
      });
      const {
        sharedLogin: { sharedUserInfo },
      } = getState();
      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `${sharedUserInfo?.payload?.token}`,
        },
      };
      const body = {
        date: dayjs(dated).format("YYYY-MM-DD"),
      };
      const { data } = await axios.post(
        `${process.env.REACT_APP_BACKEND_URI}/api/user/project/${companyId}/date`,
        body,
        config
      );
      dispatch({
        type: USER_PROJECT_TIME_LIST_SUCCESS,
        payload: data?.data,
      });
    } catch (error) {
      let err =
        error.response &&
        (typeof error.response.data === "string"
          ? error.response.data
          : error.response.data.message
          ? error.response.data.message
          : error.response.data.errors
          ? error.response.data.errors[0].msg
          : error.message);
      if (!err) {
        err = "Network Error";
      }
      //  console.log(err);
      dispatch({
        type: USER_PROJECT_TIME_LIST_FAIL,
        payload: err,
      });
      throw Error(err);
    }
  };

export const userAddProjectTimeDateAction =
  (formData, projectId, companyId) => async (dispatch, getState) => {
    try {
      dispatch({
        type: USER_PROJECT_ADD_TIME_IN_LIST_REQUEST,
      });
      const {
        sharedLogin: { sharedUserInfo },
      } = getState();
      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `${sharedUserInfo?.payload?.token}`,
        },
      };
      // console.log(formData, projectId, companyId);
      const { data } = await axios.post(
        `${process.env.REACT_APP_BACKEND_URI}/api/user/projecttime/${companyId}/addproject/${projectId}/`,
        formData,
        config
      );
      dispatch({
        type: USER_PROJECT_ADD_TIME_IN_LIST_SUCCESS,
        payload: data?.data,
      });
    } catch (error) {
      let err =
        error.response &&
        (typeof error.response.data === "string"
          ? error.response.data
          : error.response.data.message
          ? error.response.data.message
          : error.response.data.errors
          ? error.response.data.errors[0].msg
          : error.message);
      if (!err) {
        err = "Network Error";
      }
      //  console.log(err);
      dispatch({
        type: USER_PROJECT_ADD_TIME_IN_LIST_FAIL,
        payload: err,
      });
      throw Error(err);
    }
  };

export const userAddWebProjectAction =
  (companyId, formData) => async (dispatch, getState) => {
    try {
      dispatch({
        type: USER_ADD_WEB_PROJECT_LIST_REQUEST,
      });
      const {
        sharedLogin: { sharedUserInfo },
      } = getState();
      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `${sharedUserInfo?.payload?.token}`,
        },
      };
      const { data } = await axios.post(
        `${process.env.REACT_APP_BACKEND_URI}/api/user/project/${companyId}/webapp/addproject`,
        formData,
        config
      );
      dispatch({
        type: USER_ADD_WEB_PROJECT_LIST_SUCCESS,
        payload: data?.data,
      });
    } catch (error) {
      let err =
        error.response &&
        (typeof error.response.data === "string"
          ? error.response.data
          : error.response.data.message
          ? error.response.data.message
          : error.response.data.errors
          ? error.response.data.errors[0].msg
          : error.message);
      if (!err) {
        err = "Network Error";
      }
      //  console.log(err);
      dispatch({
        type: USER_ADD_WEB_PROJECT_LIST_FAIL,
        payload: err,
      });
      throw Error(err);
    }
  };

export const userEditProjectTimeAction =
  (formData, projectId, companyId) => async (dispatch, getState) => {
    try {
      dispatch({
        type: USER_PROJECT_EDIT_TIME_IN_LIST_REQUEST,
      });
      const {
        sharedLogin: { sharedUserInfo },
      } = getState();
      // console.log(formData, projectId, companyId);
      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `${sharedUserInfo?.payload?.token}`,
        },
      };
      const { data } = await axios.post(
        `${process.env.REACT_APP_BACKEND_URI}/api/user/projecttime/${companyId}/edit/${projectId}`,
        formData,
        config
      );
      dispatch({
        type: USER_PROJECT_EDIT_TIME_IN_LIST_SUCCESS,
        payload: data?.data,
      });
    } catch (error) {
      let err =
        error.response &&
        (typeof error.response.data === "string"
          ? error.response.data
          : error.response.data.message
          ? error.response.data.message
          : error.response.data.errors
          ? error.response.data.errors[0].msg
          : error.message);
      if (!err) {
        err = "Network Error";
      }
      //  console.log(err);
      dispatch({
        type: USER_PROJECT_EDIT_TIME_IN_LIST_FAIL,
        payload: err,
      });
      throw Error(err);
    }
  };

export const userAllReportAction =
  (startDate, endDate) => async (dispatch, getState) => {
    try {
      dispatch({
        type: USER_ALL_REPORT_DATA_LIST_REQUEST,
      });
      const {
        sharedLogin: { sharedUserInfo },
      } = getState();
      const body = {
        startDate: `${dayjs(startDate).format("YYYY-MM-DD")}`,
        endDate: `${dayjs(endDate).format("YYYY-MM-DD")}`,
      };
      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `${sharedUserInfo?.payload?.token}`,
        },
      };
      const { data } = await axios.post(
        `${process.env.REACT_APP_BACKEND_URI}/api/user/project/${sharedUserInfo?.empCompanies[0]?.companyId?._id}/report/all/data`,
        body,
        config
      );
      // console.log({ data });
      dispatch({
        type: USER_ALL_REPORT_DATA_LIST_SUCCESS,
        payload: data?.data,
      });
    } catch (error) {
      let err =
        error.response &&
        (typeof error.response.data === "string"
          ? error.response.data
          : error.response.data.message
          ? error.response.data.message
          : error.response.data.errors
          ? error.response.data.errors[0].msg
          : error.message);
      if (!err) {
        err = "Network Error";
      }
      //  console.log(err);
      dispatch({
        type: USER_ALL_REPORT_DATA_LIST_FAIL,
        payload: err,
      });
      throw Error(err);
    }
  };

export const userAllUserStatusAction = () => async (dispatch, getState) => {
  try {
    dispatch({
      type: USER_ALL_USER_CHECKIN_LIST_REQUEST,
    });
    const {
      sharedLogin: { sharedUserInfo },
    } = getState();
    const body = {
      date: dayjs(new Date()).format("YYYY-MM-DD"),
    };
    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `${sharedUserInfo?.payload?.token}`,
      },
    };
    const { data } = await axios.post(
      `${process.env.REACT_APP_BACKEND_URI}/api/user/${sharedUserInfo?.empCompanies[0]?.companyId?._id}/userstatus/checkin/date`,
      body,
      config
    );
    // console.log({ data });
    dispatch({
      type: USER_ALL_USER_CHECKIN_LIST_SUCCESS,
      payload: data?.data,
    });
  } catch (error) {
    let err =
      error.response &&
      (typeof error.response.data === "string"
        ? error.response.data
        : error.response.data.message
        ? error.response.data.message
        : error.response.data.errors
        ? error.response.data.errors[0].msg
        : error.message);
    if (!err) {
      err = "Network Error";
    }
    //  console.log(err);
    dispatch({
      type: USER_ALL_USER_CHECKIN_LIST_FAIL,
      payload: err,
    });
    throw Error(err);
  }
};

export const deleteProjectAction =
  (companyId, projectId) => async (dispatch, getState) => {
    try {
      dispatch({
        type: USER_PROJECT_DELETE_IN_LIST_REQUEST,
      });
      const {
        sharedLogin: { sharedUserInfo },
      } = getState();
      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `${sharedUserInfo?.payload?.token}`,
        },
      };
      const { data } = await axios.delete(
        `${process.env.REACT_APP_BACKEND_URI}/api/user/project/${companyId}/${projectId}/delete`,
        config
      );
      // console.log(data);
      dispatch({
        type: USER_PROJECT_DELETE_IN_LIST_SUCCESS,
        payload: data?.data,
      });
    } catch (error) {
      let err =
        error.response &&
        (typeof error.response.data === "string"
          ? error.response.data
          : error.response.data.message
          ? error.response.data.message
          : error.response.data.errors
          ? error.response.data.errors[0].msg
          : error.message);
      if (!err) {
        err = "Network Error";
      }
      //  console.log(err);
      dispatch({
        type: USER_PROJECT_DELETE_IN_LIST_FAIL,
        payload: err,
      });
      throw Error(err);
    }
  };

export const deleteProjectTimeAction =
  (companyId, protimeId, date) => async (dispatch, getState) => {
    try {
      dispatch({
        type: USER_PROJECT_DELETE_TIME_IN_LIST_REQUEST,
      });
      const {
        sharedLogin: { sharedUserInfo },
      } = getState();
      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `${sharedUserInfo?.payload?.token}`,
        },
      };
      let body = {
        date: dayjs(date).format("YYYY-MM-DD"),
      };
      const { data } = await axios.post(
        `${process.env.REACT_APP_BACKEND_URI}/api/user/projecttime/${companyId}/${protimeId}/delete`,
        body,
        config
      );
      dispatch({
        type: USER_PROJECT_DELETE_TIME_IN_LIST_SUCCESS,
        payload: data,
      });
    } catch (error) {
      let err =
        error.response &&
        (typeof error.response.data === "string"
          ? error.response.data
          : error.response.data.message
          ? error.response.data.message
          : error.response.data.errors
          ? error.response.data.errors[0].msg
          : error.message);
      if (!err) {
        err = "Network Error";
      }
      //  console.log(err);
      dispatch({
        type: USER_PROJECT_DELETE_TIME_IN_LIST_FAIL,
        payload: err,
      });
      throw Error(err);
    }
  };
